/* eslint-disable no-redeclare */
import { z } from 'zod';

export const PageViewDestination = z.string().min(1);

export type PageViewDestination = z.infer<typeof PageViewDestination>;
